import { useEffect, useState } from "react";
import "./App.css";
import Preloader from "./components/Preloader";
import Cursor from "./components/Cursor";
import Cinema from "./backdrop/Cinema";
import FilmRail from "./backdrop/FilmRail";
import Navbar from "./components/Navbar";
import SectionRail from "./components/SectionRail";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Journey from "./journey/Journey";
import useHorizontalMode from "./journey/useHorizontalMode";

export default function App() {
  const [ready, setReady] = useState(false);
  const horizontal = useHorizontalMode();

  // Lock scroll while the preloader is on screen, then release.
  useEffect(() => {
    document.body.style.overflow = ready ? "" : "hidden";
    if (ready) window.scrollTo({ top: 0 });
  }, [ready]);

  return (
    <>
      {!ready && <Preloader onComplete={() => setReady(true)} />}
      <div className="grain" aria-hidden />
      <Cursor />
      <Cinema />
      <FilmRail />

      <Navbar ready={ready} />
      <SectionRail />

      <Journey horizontal={horizontal}>
        <Hero ready={ready} horizontal={horizontal} />
        <About horizontal={horizontal} />
        <Skills horizontal={horizontal} />
        <Experience horizontal={horizontal} />
        <Projects horizontal={horizontal} />
        <Contact horizontal={horizontal} />
        <Footer horizontal={horizontal} />
      </Journey>
    </>
  );
}
